import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { FaLink } from "react-icons/fa6";

const ChatPreviewLink = ({
  previewLink,
  removePreviewLink,
  isInPanel = false,
}) => {
  const handleClick = () => {
    if (isInPanel && previewLink?.url) {
      window.open(previewLink.url, "_blank");
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`flex flex-1 items-center p-2 rounded-[5px] gap-2.5 
        ${
          isInPanel
            ? "cursor-pointer hover:bg-gray-100 transition-colors"
            : "bg-[#ebecf0]  m-1.5"
        }`}
    >
      {previewLink?.image ? (
        <div
          className={`flex items-center justify-center ${isInPanel ? "w-10 h-10" : "w-16 h-16"}`}
        >
          <img
            className="rounded-[5px] object-cover"
            src={previewLink?.image}
            alt="Preview"
          />
        </div>
      ) : (
        <div
          className={`flex items-center justify-center bg-gray-100 rounded-[5px] ${isInPanel ? "w-10 h-10" : "w-16 h-16"}`}
        >
          <FaLink size={25} color="#2a56b9" />
        </div>
      )}
      <div className="flex flex-1 justify-between min-w-0 gap-[10px]">
        <div className="flex flex-col flex-1 min-w-0 w-[200px]">
          <div className="font-semibold truncate">{previewLink?.title}</div>
          {!isInPanel && (
            <div className="truncate text-sm text-gray-600">
              {previewLink?.description}
            </div>
          )}
          <div className="truncate text-sm text-gray-500">
            {previewLink?.url}
          </div>
        </div>
        {!isInPanel && (
          <Button
            className="w-6"
            type="text"
            icon={<CloseOutlined />}
            onClick={removePreviewLink}
          />
        )}
      </div>
    </div>
  );
};

export { ChatPreviewLink };
